import type {IQService} from 'angular';
import {SearchManager} from './search-manager';
import type {MemoryStateManager} from './memory-state-manager';
import type {FormDataService} from '../commons/data-services/form.data-service';
import type {SearchParams, StaticSearchParams} from 'typings/portaro.be.types';
import type {UrlStateManagerService} from '../commons/services/url-state-manager.service';


/*@ngInject*/
export function searchManagerFactory(
    $q: IQService,
    memoryStateManagerFactory: () => MemoryStateManager,
    urlStateManagerService: UrlStateManagerService,
    formDataService: FormDataService): SearchManagerFactory {

    const loadFormsFunction = (params) => formDataService.getForms(params)

    return {
        createGlobalSearch:
            <PARAMS extends SearchParams, ITEM>(searchFunction, staticParams?: StaticSearchParams) =>
                new SearchManager<PARAMS, ITEM>($q, urlStateManagerService, staticParams ?? {}, searchFunction, loadFormsFunction),

        createLocalSearch:
            <PARAMS extends SearchParams, ITEM>(searchFunction, staticParams?: StaticSearchParams) =>
                new SearchManager<PARAMS, ITEM>($q, memoryStateManagerFactory(), staticParams ?? {}, searchFunction, loadFormsFunction)
    }
}

searchManagerFactory.factoryName = 'searchManagerFactory';

export interface SearchManagerFactory {

    createLocalSearch<PARAMS extends SearchParams, ITEM>(searchFunction, staticParams): SearchManager<PARAMS, ITEM>;

    createGlobalSearch<PARAMS extends SearchParams, ITEM>(searchFunction, staticParams): SearchManager<PARAMS, ITEM>;
}